import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";
import { WriteReviewPageBody } from "../components/WriteReviewPageBody";

export const Template = (
    props: Immutable<templates.WriteReviewPageDocumentTemplate>,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <WriteReviewPageBody {...props} />
    </PageSkeleton>
);
